import { createContext } from 'react'

export type ClinicLocatorContextType = {
  isMobile?: boolean
}

export const ClinicLocatorContext = createContext<ClinicLocatorContextType>(
  {} as ClinicLocatorContextType,
)
